import { ControlInterface } from '../../types/FormJson';

export default class FilePicker extends React.PureComponent<ControlInterface> {
	onFileChange = (event: React.ChangeEvent) => {
		const { onChange, name } = this.props;
		onChange([name], (event.target as HTMLInputElement).files, true);
	};

	render() {
		const { label, disabled, multiple, mandatory, name, className, error, placeholder } = this.props;

		return (
			<div className={`form-row row-${name}`}>
				<label htmlFor={name}>
					{label}
					{mandatory ? '*' : ''}
					<span className="error-title">{error}</span>
				</label>
				<input
					className={className}
					disabled={disabled}
					name={name}
					onChange={this.onFileChange}
					type="file"
					id="file"
					multiple={multiple}
					placeholder={placeholder}
				/>
			</div>
		);
	}
}
